<div class="modal active calcSettings">
  <div class="modal__container modal__container--sm" style="height: fit-content;top: 2%;max-height: none;">
    <div class="fields">
      <h2>Calculation Settings</h2>
      <div class="close" (click)="cancelConfiguration()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  name="ngCalculationForm" [formGroup]="form" id="calculationForm" class="active" style="flex-direction: row;">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Propagation Parameters</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">K Factor</label>
                  <input
                    maxlength="5"
                    [(ngModel)]="configurationController.currentConfiguration.calculation.kfactor"
                    formControlName="kfactor"
                    type="number"
                    name="kfactor"
                    id="calcKFactor"
                  />
                </div>
                <span class="error" *ngIf="form.get('kfactor').errors">
                  The kfactor value should be defined between 1 and 1.5.
                 </span>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>Calculation Increments</h4>
                <span> </span>
              </div>
              <div class="dropdown-fields">
                <div>
                  <label for="">Azimuth Increment</label>
                  <select
                      name="azimuthIncrement"
                      [(ngModel)]="configurationController.currentConfiguration.calculation.azimuthIncrement"
                      formControlName="azimutIncrement"
                      >
                      <option value="0.3">0.3</option>
                      <option value="0.5">0.5</option>
                      <option value="1.0">1.0</option>
                    </select>
                    <span>[deg]</span>
                </div>
                <div>
                  <label for="">Sector Length</label>
                  <select
                      name="sectorLength"
                      [(ngModel)]="configurationController.currentConfiguration.calculation.sectorLength"
                      formControlName="sectorLength"
                      >
                    <option value="500">500</option>
                    <option value="1000">1000</option>
                    </select>
                    <span>[m]</span>
                </div>
                <div>
                  <label for="">Summit Granularity</label>
                  <select
                      name="summitGranularity"
                      [(ngModel)]="configurationController.currentConfiguration.calculation.summitGranularity"
                      formControlName="summitGranularity"
                      >
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                      <option value="8">8</option>
                      <option value="9">9</option>
                      <option value="10">10</option>
                    </select>
                    <span> </span>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>Visibility Parameters</h4>
                <span> </span>
              </div>
              <div class="dropdown-fields">
                <div>
                  <label for="">Visibility Granularity</label>
                  <select
                      name="visibilityGranularity"
                      [(ngModel)]="configurationController.currentConfiguration.calculation.visibilityGranularity"
                      formControlName="visibilityGranularity"
                      >
                      <option value="30">30</option>
                      <option value="60">60</option>
                      <option value="120">120</option>
                    </select>
                    <span span style="width:'7%'">[arcsec]</span>
                </div>
                <div>
                  <label for="">Visibility Scaling</label>
                  <select
                      name="visibilityScaling"
                      [(ngModel)]="configurationController.currentConfiguration.calculation.visibilityScaling"
                      formControlName="visibilityScaling"
                      >
                      <option value="3x2">3x2 area (Default)</option>
                      <option value="1x1">1x1 area (No scaling)</option>
                      <option value="2x2">2x2 area</option>
                      <option value="3x3">3x3 area</option>
                      <option value="4x4">4x4 area</option>
                    </select>
                    <span style="width:'7%'"></span>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>Terrain Data</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <input
                      id="autoFillTerrainVoids"
                      name="autoFillTerrainVoids"
                      [(ngModel)]="configurationController.currentConfiguration.calculation.autoFillTerrainVoids"
                      formControlName="fillterrainVoids"
                      type="checkbox"
                    />
                    <label for="" style="width: auto;">Automatically Fill Terrain Voids</label>
                </div>
              </div>
            </div>
          </div>
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Cone of Silence Options</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Cone of Silence Defa</label>
                  <input
                    maxlength="5"
                    [(ngModel)]="configurationController.currentConfiguration.calculation.coneOfSilenceDefa"
                    formControlName="coneOfSilence"
                    type="number"
                    name="coneOfSilenceDefa"
                    id="coneOfSilenceDefa"

                  />
                  <span>[deg]</span>
                  <span class="error" *ngIf="form.get('coneOfSilence').errors">
                    The Cone Of Silence value should be defined between 5 and 60.
                   </span>

                </div>
              </div>
              <div class="input-fields">
                <div>
                  <input
                      id="useConeOfSilence"
                      name="useConeOfSilence"
                      [(ngModel)]="configurationController.currentConfiguration.calculation.useConeOfSilence"
                      formControlName="useConeOfSilence"
                      type="checkbox"
                      (click)="useConeOfSilenceSelect($event)"
                    />
                    <label for="">Use Cone of Silence</label>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>Calculation Options</h4>
                <span> </span>
              </div>
              <div class="dropdown-fields">
                <div>
                  <label for="">Elevation Type</label>
                  <select
                      name="elevationType"
                      id="elevationType"
                      [(ngModel)]="configurationController.currentConfiguration.calculation.elevationType"
                      formControlName="elevationType"
                      >
                    <option value="Published">Published Elevation</option>
                    <option value="Relative">Relative Elevation</option>
                    </select>
                </div>
              </div>
              <div class="input-fields">
                <div>
                  <input
                      id="useSectorization"
                      name="useSectorization"
                      [(ngModel)]="configurationController.currentConfiguration.calculation.useSectorization"
                      formControlName="useSectorization"
                      type="checkbox"
                    />
                    <label for="">Use Sectorization</label>
                </div>
              </div>
              <div class="dropdown-fields">
                <div>
                  <label for="">Range Limitation</label>
                  <select
                      name="rangeLimitation"
                      [(ngModel)]="configurationController.currentConfiguration.calculation.rangeLimitation"
                      formControlName="rangeLimitation" [attr.disabled]="adminRole"
                      >
                      <option value="NoLimit">No Limit</option>
                      <option value="DOC">DOC</option>
                      <option value="FOM">FOM</option>
                    </select>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>Coverage Calculation</h4>
                <span> </span>
              </div>
              <div class="dropdown-fields">
                <div>
                  <label for="">Algorithm</label>
                  <select
                      name="algorithm"
                      id="algorithm"
                      [(ngModel)]="configurationController.currentConfiguration.calculation.algorithm"
                      formControlName="algorithm"
                      (click)="coverageAlgorithmSelect($event)"
                      >
                    <option value="Screening">Screening</option>
                    <option value="Visibility">Visibility</option>
                    </select>
                </div>
              </div>
            </div>
            <div *ngIf="adminRole" class="fields__block__section">
              <div class="title">
                <h4>Negative Screening Angles</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <input
                      id="calculateNegAngles"
                      name="calculateNegAngles"
                      [(ngModel)]="configurationController.currentConfiguration.calculation.calculateNegAngles"
                      formControlName="calculateNegativeScreeningAngles"
                      type="checkbox"
                      (click)="negativeScreenAnglesSelect($event)"
                    />
                    <label for="" style="width: auto;">Calculate Negative Screening Angles</label>
                </div>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Distance to NavAid</label>
                  <input
                    maxlength="5"
                    [(ngModel)]="configurationController.currentConfiguration.calculation.distanceToNavAid"
                    formControlName="distanceToNavaid"
                    type="number"
                    name="distanceToNavAid"
                    id="distanceToNavAid"
                  />
                  <span>[NM]</span>
                  <span class="error" *ngIf="form.get('distanceToNavaid').errors">
                    The Distance To Navaid value should be defined between 0 and 500.
                   </span>
                </div>
              </div>
            </div>
          </div>
          <div class="fields__btn">
            <button type="submit" [ngClass]="form.valid ? 'blue' : 'gray'" (click)="saveConfiguration()" [disabled]="!form.valid">
              Save
            </button>
            <button type="submit" [ngClass]="form.valid ? 'blue' : 'gray'" (click)="retoreDefaults();">
              Restore Defaults
            </button>
            <button type="submit" class="blue" (click)="deleteCalculationsDatabase();">
              Delete Calculation Database
            </button>
            <button class="gray" (click)="cancelConfiguration()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
